class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.close_icon = document.querySelector('.cart-notification__close');
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    //overlay for content
    document.querySelector('.content-for-layout').classList.add('active', 'op-03');
    document.querySelector('#transcySwitcherContainer') &&  document.querySelector('#transcySwitcherContainer').classList.add('hidden');
    document.querySelector('#gorgias-chat-container') &&  document.querySelector('#gorgias-chat-container').classList.add('hidden');
    document.body.style.overflow = 'hidden';

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
    //this.close_icon.addEventListener('click', this.close());
  }

  close() {
    this.notification.classList.remove('active');
    //overlay for content
    document.querySelector('.content-for-layout').classList.remove('active', 'op-03');
    document.querySelector('#transcySwitcherContainer') &&  document.querySelector('#transcySwitcherContainer').classList.remove('hidden');
    document.querySelector('#gorgias-chat-container') &&  document.querySelector('#gorgias-chat-container').classList.remove('hidden');
    document.body.style.overflow = '';

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console_log('renderContents Initiated') 
      //this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        //console_log(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      //if (this.header) this.header.reveal();
      //don't display on the cart page
      if(location.href.indexOf('/cart') == -1){
        this.open();
      }
     
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product"]`,
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-counter-number',
        selector: `[id="cart-counter-number"]`,
      },
      {
        id: 'cart-notification-subtotal',
        selector: `[id="cart-notification-subtotal"]`,
      }

    ]; 
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
